export const data_struct = [
    { key: 'name', name: 'business-name' },
    { key: 'rfc', name: 'tax-id' },
    // { key: 'cer', name: 'cer-file' },
    // { key: 'key', name: 'key-file' },
    // { key: 'pass_phrase', name: 'pass-phrase' },
];